let DOW_SUN = 'SUN';
let DOW_MON = 'MON';
let DOW_TUE = 'TUE';
let DOW_WED = 'WED';
let DOW_THU = 'THU';
let DOW_FRI = 'FRI';
let DOW_SAT = 'SAT';

export { DOW_SUN, DOW_MON, DOW_TUE, DOW_WED, DOW_THU, DOW_FRI, DOW_SAT };
